import { apiGetHousehold } from '../../core/redux/api/endpoints';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { HouseholdMember } from './householdMember';
import { addError, addLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { addHousehold } from '../module';


const KEY_ACTION = ACTION_TYPE.HOUSEHOLD_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.HOUSEHOLD_REQUEST,
  ACTION_TYPE.HOUSEHOLD_RESPONSE,
  ACTION_TYPE.HOUSEHOLD_ERROR,
];


/**
 * Constructs a household Redux Action for getting the members of a guest's household
 * @param guestId - The guest whose household we want to get
 */
export const householdAction = (guestId: string) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (apiGetHousehold(encodeURIComponent(guestId))),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    bailout:  state => hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<HouseholdMember[]> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return addHousehold(noLoadingOrError, payload!);
};


export const householdReducer = makeApiReducer<HouseholdMember[]>(ACTIONS, KEY_ACTION, reducer);
